import axios from "axios";
import { APP_BASE_URL, GET_ASSETS, GET_DEVICE_TYPE_ASSET } from "../../Common/EndPoints";

type GetDeviceTypeListResponse = {
  data: {
    typeid: string;
    label: string;
    type: string;
  }[];
};
export function getDeviceTypeList() {
  return axios.get<GetDeviceTypeListResponse>(APP_BASE_URL + GET_DEVICE_TYPE_ASSET);
}

type GetDeviceListRequest = {
  params: {
    customerIds?: string;
    deviceTypeIds?: string;
  };
};
type Device = {
  deviceid: string;
  name: string;
  additionaldetail: {
    gear_name?: string;
    crossRefPoint?: string[];
  } & { [key: string]: string };
};
type GetDeviceListResponse = {
  data: Device[];
};
export function getDeviceList({ params }: GetDeviceListRequest) {
  return axios.get<GetDeviceListResponse>(APP_BASE_URL + GET_ASSETS, { params });
}

export const getTelemetryAssetName= (assetName: any) => {
  let _name = assetName;
  const [stn,...restName] = assetName.split('-');
  if(restName.length){
    _name =  restName.join('-')
  }
  return _name
};
export const getValueFromPath = (obj: Record<string, any>, path: string) => {
  if (!path) return null;

  // nested path
  if (path.includes("->")) {
    return path.split("->").reduce((acc, key) => acc?.[key], obj);
  }

  // simple key
  return obj?.[path];
};